import { useQuery, useMutation } from "@tanstack/react-query";
import { queryClient } from "@/shared/services/queryClient";
import {
  setupApprovalApi,
  type CreateSetupApprovalRequest,
  type ApproveSetupApprovalRequest,
  type RejectSetupApprovalRequest,
  type ResubmitSetupApprovalRequest,
} from "../services/setupApprovalApi";

export const usePendingSetupApprovals = () =>
  useQuery({
    queryKey: ["setupApprovals", "pending"],
    queryFn: setupApprovalApi.getPending,
  });

export const useSetupApprovalById = (id: string) =>
  useQuery({
    queryKey: ["setupApprovals", id],
    queryFn: () => setupApprovalApi.getById(id),
    enabled: !!id,
  });

export const useSubmitSetupApproval = () =>
  useMutation({
    mutationFn: (payload: CreateSetupApprovalRequest) =>
      setupApprovalApi.submit(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["setupApprovals"] });
    },
  });

export const useApproveSetupApproval = () =>
  useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: ApproveSetupApprovalRequest }) =>
      setupApprovalApi.approve(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["setupApprovals"] });
    },
  });

export const useRejectSetupApproval = () =>
  useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: RejectSetupApprovalRequest }) =>
      setupApprovalApi.reject(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["setupApprovals"] });
    },
  });

export const useMySetupApprovals = () =>
  useQuery({
    queryKey: ["setupApprovals", "my-submissions"],
    queryFn: setupApprovalApi.getMySubmissions,
  });

export const useResubmitSetupApproval = () =>
  useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: ResubmitSetupApprovalRequest }) =>
      setupApprovalApi.resubmit(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["setupApprovals"] });
    },
  });
